import Logger from 'src/lib/Logger.js'

const qp = new URLSearchParams(window.location.search)
if (import.meta.env.VITE_TARGET_ENV !== 'production' || qp.get('debug') === '1') {
  // set debug localStorage entry
  localStorage.setItem('peg_debug', 1)
} else if (qp.get('debug')) {
  // remove debug localStorage entry
  localStorage.removeItem('peg_debug')
}

export const $logger = new Logger({ key: 'peg_debug' })
